import React from 'react'
import { ReactComponent as SvgInstagram } from './instagram.svg';
import { Button } from 'react-bootstrap';
import { useState } from "react";

export default function Footer() {
    const openInstagram = () => {
        window.open("https://www.instagram.com/vintage_soluciones/", "_blank", "noopener,noreferrer");
    };

    const [isHovered, setIsHovered] = useState(false);

    return (
        <section className="py-4 text-center d-flex flex-column align-items-center justify-content-center bg-light">
            <h2 className="text-secondary mb-4"
                style={{
                    lineHeight: "1.2",
                    cursor: "default",
                    letterSpacing: "1px"
                }}>
                ¿Queres ver más? Ingresa a nuestro Instagram!
            </h2>
            <div className="d-flex justify-content-center">
                <Button
                    onClick={openInstagram}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    style={{
                        borderRadius: "82px",
                        padding: "14px",
                        background: isHovered
                            ? "linear-gradient(45deg, #d8b02c, #cc256b, #5122b0)"
                            : "linear-gradient(45deg, #f9ce34, #ee2a7b, #6228d7)",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "background 0.3s ease-in-out",
                    }}
                >
                    <SvgInstagram
                        className="text-center"
                        style={{
                            width: "44px",
                            height: "44px",
                            fill: "white",
                        }}
                    />
                </Button>
            </div>
        </section>
    )
}
